!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("prop-types"), require("react"), require("vega-lib")) : "function" == typeof define && define.amd ? define(["prop-types", "react", "vega-lib"], t) : "object" == typeof exports ? exports.ReactVega = t(require("prop-types"), require("react"), require("vega-lib")) : e.ReactVega = t(e.PropTypes, e.React, e.vega);
}(this, function (e, t, n) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var i = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 7);
  }([function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var o = n(6),
        u = (n.n(o), n(5)),
        c = n(1),
        s = n.n(c),
        p = n(2),
        f = n.n(p),
        l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        d = {
      className: s.a.string,
      style: s.a.object,
      spec: s.a.object.isRequired,
      logLevel: s.a.number,
      width: s.a.number,
      height: s.a.number,
      tooltip: s.a.func,
      background: s.a.string,
      padding: s.a.object,
      renderer: s.a.string,
      enableHover: s.a.bool,
      data: s.a.object,
      onNewView: s.a.func,
      onParseError: s.a.func
    },
        h = {
      className: "",
      renderer: "svg",
      enableHover: !0,
      onNewView: function onNewView() {},
      onParseError: function onParseError() {}
    },
        v = function (e) {
      function t() {
        return r(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return a(t, e), l(t, [{
        key: "componentDidMount",
        value: function value() {
          this.createView(this.props.spec);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          var n = this;
          if (this.props.spec !== e.spec) this.clearView(), this.createView(this.props.spec);else if (this.view) {
            var r = this.props,
                i = this.props.spec,
                a = !1;
            ["width", "height", "renderer", "logLevel", "background"].filter(function (t) {
              return r[t] !== e[t];
            }).forEach(function (e) {
              n.view[e](r[e]), a = !0;
            }), t.isSamePadding(r.padding, e.padding) || (this.view.padding(r.padding || i.padding), a = !0), i.data && r.data && i.data.forEach(function (i) {
              var o = e.data[i.name],
                  u = r.data[i.name];
              t.isSameData(o, u) || (n.updateData(i.name, u), a = !0);
            }), r.enableHover !== e.enableHover && (a = !0), a && (r.enableHover && this.view.hover(), this.view.run());
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.clearView();
        }
      }, {
        key: "createView",
        value: function value(e) {
          var r = this;

          if (e) {
            var i = this.props;

            try {
              var a = o.parse(e),
                  c = new o.View(a).initialize(this.element);
              e.signals && e.signals.forEach(function (e) {
                c.addSignalListener(e.name, function () {
                  for (var n = arguments.length, i = Array(n), a = 0; a < n; a++) {
                    i[a] = arguments[a];
                  }

                  var o = r.props[t.listenerName(e.name)];
                  o && o.apply(r, i);
                });
              }), this.view = c, ["logLevel", "renderer", "tooltip", "background", "width", "height", "padding"].filter(function (e) {
                return n.i(u.a)(i[e]);
              }).forEach(function (e) {
                c[e](i[e]);
              }), e.data && i.data && e.data.filter(function (e) {
                return i.data[e.name];
              }).forEach(function (e) {
                r.updateData(e.name, i.data[e.name]);
              }), i.enableHover && c.hover(), c.run(), i.onNewView(c);
            } catch (e) {
              this.clearView(), i.onParseError(e);
            }
          } else this.clearView();

          return this;
        }
      }, {
        key: "updateData",
        value: function value(e, t) {
          t && (n.i(u.b)(t) ? t(this.view.data(e)) : this.view.change(e, o.changeset().remove(function () {
            return !0;
          }).insert(t)));
        }
      }, {
        key: "clearView",
        value: function value() {
          return this.view && (this.view.finalize(), this.view = null), this;
        }
      }, {
        key: "render",
        value: function value() {
          var e = this;
          return f.a.createElement("div", {
            ref: function ref(t) {
              e.element = t;
            },
            className: this.props.className,
            style: this.props.style
          });
        }
      }], [{
        key: "isSamePadding",
        value: function value(e, t) {
          return n.i(u.a)(e) && n.i(u.a)(t) ? e.top === t.top && e.left === t.left && e.right === t.right && e.bottom === t.bottom : e === t;
        }
      }, {
        key: "isSameData",
        value: function value(e, t) {
          return e === t && !n.i(u.b)(e);
        }
      }, {
        key: "isSameSpec",
        value: function value(e, t) {
          return e === t || JSON.stringify(e) === JSON.stringify(t);
        }
      }, {
        key: "listenerName",
        value: function value(e) {
          return "onSignal" + n.i(u.c)(e);
        }
      }]), t;
    }(f.a.Component);

    v.propTypes = d, v.defaultProps = h, t.a = v;
  }, function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n.d(t, "createClassFromSpec", function () {
      return a;
    });
    var r = n(0),
        i = n(4);
    t.default = r.a;
    var a = i.a;
  }, function (e, t, n) {
    "use strict";

    function r() {
      function e(e) {
        return a.a.createElement(c.a, s({
          spec: t
        }, e));
      }

      var t = 1 === arguments.length ? arguments.length <= 0 ? void 0 : arguments[0] : arguments.length <= 1 ? void 0 : arguments[1],
          n = Object.assign({}, c.a.propTypes);
      return delete n.spec, t.signals && t.signals.forEach(function (e) {
        n[c.a.listenerName(e.name)] = u.a.func;
      }), e.getSpec = function () {
        return t;
      }, e.propTypes = n, e;
    }

    t.a = r;

    var i = n(2),
        a = n.n(i),
        o = n(1),
        u = n.n(o),
        c = n(0),
        s = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }

    function i(e) {
      return null !== e && void 0 !== e;
    }

    function a(e) {
      var t = {};
      return !!e && "[object Function]" === t.toString.call(e);
    }

    t.c = r, t.a = i, t.b = a;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, n) {
    e.exports = n(3);
  }]);
});